<template>
  <ul class="ul_user_select">
    <li class="select_content">
      <img :src="getImage('top/content/choosepoint_01.webp')">
      <div>
        <div class="pickup_title">1.【明瞭会計】追加料金一切なし！</div>
        <p>
          お客様がmm/styleで商品をカスタマイズすると、すぐにお見積り価格が表示されます。その価格から、追加で費用がかかることはございません。<br>
          明瞭価格をご確認いただきながら、お買い物をしていただけます。
        </p>
      </div>
    </li>
    <li class="select_content">
      <img :src="getImage('top/content/choosepoint_02.webp')">
      <div>
        <div class="pickup_title">2.【品質保証】1年間の無償修理保証！</div>
        <p>
          配達中の商品破損や、取扱説明書に従った使用状態で保証期間内に故障した場合は、無償修理の対応をさせていただきます。<br>
          mm/styleに掲載されている全ての商品が保証対象です。
        </p>
      </div>
    </li>
    <li class="select_content">
      <img :src="getImage('top/content/choosepoint_03.webp')">
      <div>
        <div class="pickup_title">3.【組設対応】プロによる組立設置対応が可能！</div>
        <p>
          商品の購入と合わせて家具のプロに組立設置を依頼することができるので、安心してご購入いただくことができます。<br>
          その場合、梱包材料は全て回収させていただきます。
        </p>
      </div>
    </li>
  </ul>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../../css/dc-mainmenu.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/DcSelectReason.vue